import LogRocket from 'logrocket';
const version  = require('./../../package.json').version

const initLogRocket = function initLogRocket(userData) {
   if(process.env.NODE_ENV == 'production') {
    LogRocket.init(process.env.VUE_APP_LOG_ROCKET_ID);
    if(userData) {
      LogRocket.identify(userData.id, {
        name: userData.name,
        version:version,
        email: userData.email,
        // Add your own custom user variables here, ie:
        companyID: userData.company.id,
        company: userData.company.name
      });
    }
  }
};


export default initLogRocket;